import Vue from "vue";
import Vuex from "vuex";
import userAccount from "@/store/modules/userAccount.js";
import groupErrorFilters from "@/store/modules/groupErrorFilters.js";
import workflowSearch from "@/store/modules/workflowSearch.js";
import workflowComplaince from "@/store/modules/workflowComplaince.js";
import commonStore from "@/store/commonStore.js";
import referencesModule from "@/store/referencesModule.js";
import auditLogModule from "@/store/auditLogModule.js";
import notificationsModule from "@/store/modules/notification/notificationsModule.js";
import bolDetails from "@/store/modules/bolDetails.js";
import billOfLading from "@/store/modules/billOfLading.js";
import portcallModule from "@/store/modules/portcall/portcallModule.js";
import manifestModule from "@/store/modules/manifest";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  modules: {
    userAccount,
    groupErrorFilters,
    workflowSearch,
    workflowComplaince,
    bolDetails,
    billOfLading,
    commonStore,
    notificationsModule,
    manifestModule,
    portcallModule,
    referencesModule,
    auditLogModule
  }
});
